<template>
  <div class="max-w-6xl mx-auto px-4 py-6">
    <!-- Encabezado de sección -->
    <header v-if="title || subtitle" class="mb-6">
      <h2 v-if="title" class="text-xl font-semibold text-gray-900">
        {{ title }}
      </h2>
      <p v-if="subtitle" class="mt-1 text-sm text-gray-500">
        {{ subtitle }}
      </p>
    </header>

    <!-- Grid responsivo: 1 col móvil, 2 tablet, 3 desktop -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      <epc-card
        v-for="item in items"
        :key="item.code"
        :title="item.title"
        :description="item.description"
        :tag="item.tag"
        :icon="item.icon"
        :color="item.color"
        :action-label="item.actionLabel || actionLabel"
        @click="$emit('item-click', item)"
      />
    </div>
  </div>
</template>

<script>
import EpcCard from './EpcCard.vue'

export default {
  name: 'EpcCardGrid',

  components: { EpcCard },

  props: {
    /** Título principal de la sección. Omitir para no renderizar el encabezado. */
    title:    { type: String, default: '' },
    /** Subtítulo descriptivo de la sección. */
    subtitle: { type: String, default: '' },
    /**
     * Items a renderizar. Cada item:
     *   { code, title, description, tag, icon, color, actionLabel? }
     * `color` soporta: 'blue' | 'amber' | 'red' (default 'blue')
     */
    items:       { type: Array, required: true },
    /** Texto del link de acción si el item no lo sobreescribe. */
    actionLabel: { type: String, default: 'Añadir' },
  },
}
</script>
